export const FILTER_OPTIONS = {
  MAIN_ACCOUNT: 'mainAccount',
  BUCKETS: 'buckets',
};

export const STATEMENT_TYPE = {
  SAVING_BUCKET: 'SAVING_BUCKET',
  EMERGENCY_BUCKET: 'EMERGENCY_BUCKET',
  TAX_BUCKET: 'TAX_BUCKET',
};

export const NO_DROP_DOWN = null;
